'use strict';

import module from './peeps.module';

module.controller('PeepsController', [
  'AppService',
  'FriendsService',
  function (AppService, FriendsService) {
    var ctrl = this;
    AppService.pageTitle = 'Friends';

    this.msg = "We got'em for all yo friends!";
    FriendsService.friends.then(function (data) {
      ctrl.friends = data;
    });
  },
]);
